import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import { QuestionnaireFormLabel } from 'spa/member/components/QuestionnaireFormLabel'
import styled from 'styled-components';
import AlertIcon from 'images/alert_icon.svg'

export type StyledNumberSelectFormProps = {
  name: string;
  label: string;
  annotationNote?: string;
  required?: boolean;
  rules?: any;
  start: number;
  end: number;
  step: number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void,
  dataCy?: string;
} & React.InputHTMLAttributes<HTMLInputElement>

const StyledSelect = styled(Select)<{ hasError?: boolean }>`

  /* Main container */
  .select__control {
    // styles for the control
    height: 3rem;
    font-size: .875rem;
    border-radius: 0;
    background-color: ${props => props.hasError ? '#FFEDED' : props.theme.members.colors.white};  color: ${props => props.theme.members.colors.black._100};
    border: 1px solid ${props => props.hasError ? '#D52020' : props.theme.members.colors.silver._70};
  }

  /* Input */
  .select__input {
    // styles for the input
  }

  .select__value-container {
    position: static;
    padding: 0 1rem;
    color: ${props => props.theme.members.colors.black._100};
  }

  /* Dropdown menu */
  .select__menu {
    // styles for the menu
  }

  /* Option in dropdown */
  .select__option {
    font-size: .875rem;
    padding: .5rem 1rem;
  }

  /* Selected value */
  .select__single-value {
    margin: 0;

    + div {
      margin: 0;
    }
  }

  /* Dropdown indicators (arrow) */
  .select__indicators {
    // styles for the indicator container
  }

  .select__indicator {
    color: ${props => props.theme.members.colors.silver._70};

    &:hover {
      color: ${props => props.theme.members.colors.silver._70};
    }
  }

  /* Dropdown indicator (arrow) */
  .select__indicator-separator {
    display: none;
  }

  .select__placeholder {
    margin: 0;
  }
`
const ErrorMessage = styled.span`
  color: #ff0000;
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
`;

export const StyledNumberSelectForm: React.FC<StyledNumberSelectFormProps> = (props: StyledNumberSelectFormProps) => {
  const { control } = useFormContext();
  const generateOptions = (start: number, end: number, step: number) => {
    const options = [];
    for (let i = start; i <= end; i += step) {
      options.push({ value: i, label: i.toLocaleString() });
    }
    return options;
  }
  const options = generateOptions(props.start, props.end, props.step);
  const [filteredOptions, setFilteredOptions] = useState(options)
  const { formState: { errors } } = useFormContext();


  const handleInputChange = (inputValue: string, { action }: { action: string }) => {
    if (action === 'input-change' && inputValue) {
      const cleanInput = inputValue.replace(/,/g, '');
      const filtered = options.filter(option =>
        option.value.toString().startsWith(cleanInput)
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  };
  return (
    <div data-cy={props.dataCy}>
      <QuestionnaireFormLabel htmlFor={props.name} label={props.label} required={props.required} annotationNote={props.annotationNote}/>
      <Controller
        name={props.name}
        control={control}
        rules={props.rules}
        render={({ field }) => (
          <>
            <StyledSelect
              {...field}
              options={filteredOptions}
              value={options.find(option => option.value === Number(field.value))}
              hasError={!!errors[props.name]}
              onChange={(selectedOption) => {
                field.onChange(selectedOption.value);
                props.onChange?.({ target: { value: selectedOption.value } } as React.ChangeEvent<HTMLSelectElement>);
              }}
              onInputChange={handleInputChange}
              classNamePrefix="select"
              placeholder="選択してください"
            />
            {errors[props.name] && (
            <ErrorMessage><img className="inline" src={AlertIcon} />{errors[props.name].message}</ErrorMessage>
            )}
          </>
        )}
      />
    </div>
  );
};
